import { memo } from "react";

import Youtube from "../../../../../public/assets/icon/sns/youtube.svg?react";
import { IconCreator } from "../_utils/icon-creator";

import type { SVGIconProps } from "../_utils/icon-creator";

const YoutubeIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: Youtube });
	return <Icon />;
};

export default memo(YoutubeIcon);
